import { render, staticRenderFns } from "./attach-file.vue?vue&type=template&id=4da08add&scoped=true&"
import script from "./attach-file.vue?vue&type=script&lang=js&"
export * from "./attach-file.vue?vue&type=script&lang=js&"
import style0 from "./attach-file.vue?vue&type=style&index=0&id=4da08add&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da08add",
  null
  
)

export default component.exports